module.exports = __webpack_public_path__ + "img/pmg-none-active.9d21610c.png";